export enum BooleanValue {
  TRUE = '1',
  FALSE = '0'
}
